/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S18_I2_TextInputs */

const tr_kullanim_s18_i2_text = /** @type {(inputs: Kullanim_S18_I2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bir maddenin geçersizliği diğer maddelerin geçerliliğini etkilemez.`)
};

const en_kullanim_s18_i2_text = /** @type {(inputs: Kullanim_S18_I2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the invalidity of one clause does not affect the validity of the other clauses.`)
};

const de_kullanim_s18_i2_text = /** @type {(inputs: Kullanim_S18_I2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`die Unwirksamkeit einer Bestimmung berührt die Wirksamkeit der übrigen Bestimmungen nicht.`)
};

const ru_kullanim_s18_i2_text = /** @type {(inputs: Kullanim_S18_I2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`недействительность одного пункта не влияет на действительность остальных пунктов.`)
};

/**
* | output |
* | --- |
* | "the invalidity of one clause does not affect the validity of the other clauses." |
*
* @param {Kullanim_S18_I2_TextInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s18_i2_text = /** @type {((inputs?: Kullanim_S18_I2_TextInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S18_I2_TextInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s18_i2_text(inputs)
	if (locale === "de") return de_kullanim_s18_i2_text(inputs)
	if (locale === "ru") return ru_kullanim_s18_i2_text(inputs)
	return tr_kullanim_s18_i2_text(inputs)
});